<div mat-dialog-title class="adlg-titlebar">
  <div class="adlg-sibnav" *ngIf="showStepper">
    <button mat-icon-button [disabled]="!canPrevious" (click)="step(-1)" [attr.aria-label]="'@previous' | translate">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="adlg-position">{{ '@alertPosition' | translate: { n: siblingIndex + 1, total: siblingCount } }}</span>
    <button mat-icon-button [disabled]="!canNext" (click)="step(1)" [attr.aria-label]="'@next' | translate">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  <span class="adlg-sev-badge" [ngClass]="severityClass">{{ current?.severity }}</span>
  <div class="adlg-title-stack">
    <span class="adlg-title-line"><span class="adlg-title-prefix">{{ '@alert' | translate }}:</span> <span class="adlg-title">{{ current?.subject }}</span></span>
    <span class="adlg-subtitle">
      <span>{{ '@lastFiredAgo' | translate: { when: (current?.lastFiredAtUtc | timeAgo) } }}</span>
      <span>{{ current?.lastFiredAtUtc | date:'medium' }}</span>
      <span class="adlg-count">{{ '@totalOccurrences' | translate }}: {{ current?.count }}</span>
    </span>
  </div>
  <button mat-icon-button class="adlg-close" (click)="close()" [attr.aria-label]="'@close' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="adlg-body">
  <div class="adlg-col adlg-main">

    <div class="adlg-asset">
      <div class="adlg-cell" *ngIf="vehicleName">
        <div class="adlg-info-label">{{ '@vehicle' | translate }}</div>
        <div class="adlg-info-value">{{ vehicleName }}</div>
      </div>
      <div class="adlg-cell" *ngIf="vin">
        <div class="adlg-info-label">{{ '@vin' | translate }}</div>
        <div class="adlg-info-value">{{ vin }}</div>
      </div>
      <div class="adlg-cell" *ngIf="makeModel">
        <div class="adlg-info-label">{{ '@makeModel' | translate }}</div>
        <div class="adlg-info-value">{{ makeModel }}</div>
      </div>
      <div class="adlg-cell" *ngIf="engine">
        <div class="adlg-info-label">{{ '@engine' | translate }}</div>
        <div class="adlg-info-value">{{ engine }}</div>
      </div>
      <div class="adlg-cell link" *ngIf="driverLabel" (click)="showDriverDetails()">
        <div class="adlg-info-label">{{ '@driver' | translate }}</div>
        <div class="adlg-info-value">{{ driverLabel }} <mat-icon class="adlg-cell-ico">calendar_month</mat-icon></div>
      </div>
    </div>

    <div *ngIf="loading" class="adlg-loading">
      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
    </div>

    <div *ngIf="error && !loading" class="adlg-error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ '@loadError' | translate }}</span>
    </div>

    <div class="adlg-two-up" *ngIf="!loading && !error">
      <div class="adlg-stack">
        <div class="adlg-section" *ngIf="triggeredFaults.length">
          <div class="adlg-section-title">{{ '@triggeredFault' | translate }}</div>
          <div class="adlg-fault-list">
            <div class="adlg-fault-row adlg-fault-card triggered" *ngFor="let fault of triggeredFaults" [ngClass]="severityClass">
              <ng-container *ngTemplateOutlet="faultRow; context: { $implicit: fault }"></ng-container>
            </div>
          </div>
        </div>

        <div class="adlg-section" *ngIf="otherFaults.length">
          <button type="button" class="fhd-btn adlg-faults-toggle" data-e2e="adlg-other-faults-toggle"
                  [class.open]="otherFaultsOpen" [attr.aria-expanded]="otherFaultsOpen" (click)="otherFaultsOpen = !otherFaultsOpen">
            <mat-icon aria-hidden="true">warning</mat-icon>
            <span class="adlg-toggle-label">{{ (triggeredFaults.length ? '@otherFaults' : '@faults') | translate }}: {{ otherFaults.length }}</span>
            <mat-icon class="adlg-toggle-go" aria-hidden="true">{{ otherFaultsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="adlg-fault-rows" *ngIf="otherFaultsOpen">
            <div class="adlg-fault-head" *ngIf="otherFaults.length > 1">
              <button type="button" class="adlg-sort-btn" *ngFor="let col of otherFaultColumns"
                      [class.active]="otherSort === col.key" [attr.data-sort]="col.key"
                      [attr.aria-sort]="otherSort === col.key ? (otherDir === 'asc' ? 'ascending' : 'descending') : 'none'"
                      (click)="sortOtherFaults(col.key)">
                {{ col.labelKey | translate }}<span class="adlg-sort-arrow" *ngIf="otherSort === col.key">{{ otherDir === 'asc' ? '▲' : '▼' }}</span>
              </button>
            </div>
            <div class="adlg-fault-row adlg-other-fault" *ngFor="let fault of visibleOtherFaults; trackBy: trackFault"
                 [attr.data-fault]="fault.faultCode + '|' + fault.failureCode">
              <ng-container *ngTemplateOutlet="faultRow; context: { $implicit: fault }"></ng-container>
            </div>
          </div>
          <mat-paginator class="adlg-fault-pager" *ngIf="otherFaultsOpen && otherFaults.length > otherFaultsPageSize"
                         [length]="otherFaults.length" [pageSize]="otherFaultsPageSize" [pageIndex]="otherPage"
                         [hidePageSize]="true" (page)="onOtherFaultsPage($event)"></mat-paginator>
        </div>

        <div class="adlg-section" *ngIf="sensorGroups.length">
          <button type="button" class="fhd-btn adlg-sensors-toggle" data-e2e="adlg-sensors-toggle"
                  [class.open]="sensorsOpen" [attr.aria-expanded]="sensorsOpen" (click)="sensorsOpen = !sensorsOpen">
            <mat-icon aria-hidden="true">sensors</mat-icon>
            <span class="adlg-toggle-label">{{ '@sensors' | translate }}</span>
            <mat-icon class="adlg-toggle-go" aria-hidden="true">{{ sensorsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="adlg-sensor-table" *ngIf="sensorsOpen">
            <span class="adlg-col-head first">{{ '@valueType' | translate }}</span>
            <span class="adlg-col-head num">{{ '@atAlert' | translate }}</span>
            <span class="adlg-col-head num">{{ '@now' | translate }}</span>
            <span class="adlg-col-head num last span-trend">{{ '@lastUpdate' | translate }}</span>
            <ng-container *ngFor="let group of sensorGroups">
              <div class="adlg-sensor-head">
                <span class="adlg-fr-base">{{ group.name }}</span>
                <span class="adlg-part-tag" *ngIf="group.partType">{{ group.partType }}</span>
              </div>
              <ng-container *ngFor="let reading of group.readings">
                <span class="adlg-sensor-type">{{ reading.valueType }}</span>
                <span class="adlg-sensor-val at">{{ reading.atAlert | sensorValue: reading.valueType }}</span>
                <span class="adlg-sensor-val now" [class.changed]="reading.trend && reading.trend !== 'flat'">{{ reading.now === null ? '—' : (reading.now | sensorValue: reading.valueType) }}</span>
                <span class="adlg-trend-mark" [class.changed]="reading.trend && reading.trend !== 'flat'">{{ trendGlyph(reading.trend) }}</span>
                <span class="adlg-sensor-when" [matTooltip]="reading.nowAt | date:'medium'">{{ reading.nowAt | timeAgo }}</span>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="adlg-stack">
        <div class="adlg-section">
          <div class="adlg-lamp-head">
            <div class="adlg-section-title">{{ '@warningLamps' | translate }}</div>
            <div class="adlg-seg" role="tablist" [attr.aria-label]="'@warningLamps' | translate">
              <button type="button" role="tab" class="adlg-seg-btn" data-e2e="adlg-lamp-tab-alert"
                      [class.active]="lampTab === 'alert'" [attr.aria-selected]="lampTab === 'alert'"
                      (click)="lampTab = 'alert'">
                {{ '@atAlert' | translate }}
                <ng-container *ngIf="lampTab !== 'alert'">
                  <ng-container *ngTemplateOutlet="lampMark; context: { $implicit: changedLamps.size }"></ng-container>
                </ng-container>
              </button>
              <span class="adlg-seg-wrap" [matTooltip]="currentLamps ? '' : ('@noCurrentLampData' | translate)">
                <button type="button" role="tab" class="adlg-seg-btn" data-e2e="adlg-lamp-tab-current"
                        [class.active]="lampTab === 'current'" [attr.aria-selected]="lampTab === 'current'"
                        [disabled]="!currentLamps" (click)="lampTab = 'current'">
                  {{ '@current' | translate }}
                  <ng-container *ngIf="lampTab !== 'current'">
                    <ng-container *ngTemplateOutlet="lampMark; context: { $implicit: changedLamps.size }"></ng-container>
                  </ng-container>
                </button>
              </span>
            </div>
          </div>
          <div class="adlg-lamp-tiles" role="tabpanel">
            <div class="adlg-lamp-row" *ngFor="let lamp of shownLamps" [class.lit]="lamp.on" [class.changed]="changedLamps.has(lamp.key)">
              <img class="adlg-lamp" [class.on]="lamp.on" [attr.data-lamp]="lamp.key" [src]="lampSrc(lamp)"
                   [alt]="(lamp.on ? lamp.onKey : lamp.offKey) | translate">
              <span class="adlg-lamp-name">{{ lamp.labelKey | translate }}</span>
            </div>
          </div>
        </div>

        <div class="adlg-section" *ngIf="actions.lead || actions.items.length">
          <div class="adlg-section-title">{{ '@recommendedActions' | translate }}</div>
          <div class="adlg-message">
            <p *ngIf="actions.lead">{{ actions.lead }}</p>
            <ol *ngIf="actions.items.length">
              <li *ngFor="let item of actions.items">{{ item }}</li>
            </ol>
          </div>
        </div>

        <div class="adlg-section adlg-rule" *ngIf="ruleSummary || ruleTags.length">
          <div class="adlg-section-title">{{ '@alertCategory' | translate }}</div>
          <div class="adlg-rule-expr" *ngIf="ruleSummary">{{ ruleSummary }}</div>
          <div class="adlg-tags" *ngIf="ruleTags.length">
            <span class="adlg-tag" *ngFor="let tag of ruleTags">{{ tag }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="adlg-section adlg-history" *ngIf="historyLoaded">
      <div class="adlg-section-title">{{ '@previousAlertsTitle' | translate: { days: historyDays } }}<ng-container *ngIf="vehicleName"> · {{ vehicleName }}</ng-container></div>
      <div class="adlg-trend" *ngIf="sparkRead">
        <div class="adlg-spark" role="img" [attr.aria-label]="'@firingsPerDay' | translate: { days: historyDays }">
          <i *ngFor="let b of buckets" [class.hit]="b > 0" [style.height.px]="barHeight(b)"></i>
        </div>
        <span class="adlg-spark-cap">{{ (sparkRead.days === 1 ? '@sparkReadToday' : '@sparkRead') | translate: sparkRead }}</span>
      </div>
      <app-alert-history-panel *ngIf="history.length; else noHistory" [rows]="history" [currentId]="current?.latestAlertId"
                               [openCase]="openCase"></app-alert-history-panel>
      <ng-template #noHistory>
        <div class="adlg-note">{{ '@noPreviousAlerts' | translate: { days: historyDays } }}</div>
      </ng-template>
      <div class="adlg-note adlg-truncated" *ngIf="historyTruncated">{{ '@showingLastAlerts' | translate: { n: historyLimit } }}</div>
    </div>

    <div class="adlg-section adlg-others" *ngIf="otherOpenAlerts.length">
      <div class="adlg-section-title">{{ '@otherOpenAlerts' | translate }}</div>
      <div class="adlg-table-wrap">
        <table class="adlg-table">
          <thead>
            <tr>
              <th>{{ '@alert' | translate }}</th>
              <th>{{ '@severity' | translate }}</th>
              <th></th>
              <th>{{ '@lastFired' | translate }}</th>
              <th>{{ '@occurrences' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of otherOpenAlerts; trackBy: trackOtherOpen" class="adlg-other-row clickable"
                [attr.data-alert-id]="o.alert.latestAlertId" (click)="stepTo(o.index)">
              <td class="wrap">{{ o.alert.subject }}</td>
              <td><span class="adlg-dot" [ngClass]="'sev-' + (o.alert.severity || '').toLowerCase()"></span>{{ o.alert.severity }}</td>
              <td><ng-container *ngTemplateOutlet="miniLamps; context: { $implicit: siblingLamps[o.alert.latestAlertId] }"></ng-container></td>
              <td class="tnum" [matTooltip]="o.alert.lastFiredAtUtc | date:'medium'">{{ o.alert.lastFiredAtUtc | timeAgo }}</td>
              <td class="tnum">{{ o.alert.count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="adlg-col adlg-side">
    <div class="adlg-section" *ngIf="alertLoaded">
      <div class="adlg-section-title adlg-section-row">
        <span>{{ '@location' | translate }}</span>
        <span class="adlg-meta adlg-assigned" *ngIf="assignedLocation" [matTooltip]="'@assignedLocation' | translate">
          <mat-icon>home</mat-icon>{{ assignedLocation }}
        </span>
      </div>

      <div class="adlg-map-wrap" *ngIf="mapPlan && !mapsFailed">
        <div #triageMap [id]="mapElementId" class="adlg-map"></div>
        <div class="adlg-map-legend">
          <span *ngFor="let pin of mapPlan.pins"><i [ngClass]="'adlg-pin-' + pin.kind"></i>{{ pinLabelKey(pin.kind) | translate }}</span>
        </div>
        <button type="button" class="adlg-map-expand" [disabled]="!assetId" (click)="openInServiceCenter()"
                [attr.aria-label]="'@openInServiceCenterMap' | translate" [matTooltip]="'@openInServiceCenterMap' | translate">
          <mat-icon>open_in_full</mat-icon>
        </button>
      </div>

      <div class="adlg-loc-row" *ngIf="shopGroup; else otr">
        <svg class="adlg-loc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10 12 4l9 6"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></svg>
        <span class="adlg-loc-stack">
          <span class="adlg-loc-lbl">{{ '@currentLocation' | translate }}</span>
          <span class="adlg-loc-main">{{ shopGroup.name }}</span>
        </span>
      </div>

      <ng-template #otr>
        <div class="adlg-loc-row">
          <svg class="adlg-loc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3v2M12 9v2M12 15v2M12 21v0"/><path d="M4 21 8 3M20 21 16 3"/></svg>
          <span class="adlg-loc-stack">
            <span class="adlg-loc-lbl">{{ '@currentLocation' | translate }}</span>
            <span class="adlg-loc-main">{{ '@otr' | translate }}</span>
          </span>
          <span class="adlg-loc-dist" *ngIf="driftDistance">
            {{ '@fromAlertLocation' | translate: { distance: driftDistance } }}
          </span>
        </div>
      </ng-template>
    </div>

    <div class="adlg-section adlg-issue" *ngIf="alertLoaded && (issuesEnabled || showCasePanel)">
      <div class="adlg-section-title">{{ (issuesEnabled ? '@issueForThisAlert' : '@case') | translate }}</div>

      <ng-container *ngIf="issuesEnabled; else caseOnly">
        <div class="adlg-issue-card" *ngIf="paneIssue && assetId; else noIssue">
          <app-issue-detail [issueId]="paneIssue.id" [assetId]="assetId" [assetGroups]="alertGroups"
                            [seedIssue]="paneIssue" [canMaintain]="canReport" [showHeader]="true" [showClose]="false"
                            [collapsibleBody]="true" (caseChanged)="refreshIssues()"></app-issue-detail>
        </div>
        <ng-template #noIssue>
          <div class="adlg-issue-card adlg-report" *ngIf="reporting; else emptyIssue">
            <div class="adlg-report-title">
              <mat-icon>flag</mat-icon>
              <span>{{ '@issueReportTitle' | translate }}</span>
              <span class="adlg-meta" *ngIf="vehicleName">{{ vehicleName }}</span>
            </div>
            <app-report-issue-form [assetId]="assetId" [assetName]="vehicleName" [assetVin]="vin" [openIssues]="issues"
                                   [showVehicle]="false" (reported)="onReported($event)" (cancelled)="reporting = false"></app-report-issue-form>
          </div>
          <ng-template #emptyIssue>
            <div class="adlg-issue-pending" *ngIf="pendingReport">
              <mat-progress-spinner mode="indeterminate" diameter="18"></mat-progress-spinner>
              <span>{{ '@issueReportSubmittedToast' | translate }}</span>
            </div>
            <div class="adlg-loading" *ngIf="!pendingReport && issuesLoading">
              <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
            </div>
            <div class="adlg-issue-empty" *ngIf="!pendingReport && !issuesLoading && issuesLoaded">
              <mat-icon>check_circle</mat-icon>
              <div class="adlg-issue-empty-title">{{ '@issueNoOpen' | translate }}</div>
              <div class="adlg-issue-empty-sub">{{ '@issueNoOpenSub' | translate }}</div>
              <button type="button" class="fhd-btn" *ngIf="canReport" data-e2e="adlg-report-issue"
                      [disabled]="!assetId" (click)="reporting = true">
                {{ '@issueReportEntry' | translate }}
              </button>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>

      <ng-template #caseOnly>
        <div class="adlg-issue-card adlg-case" *ngIf="showCasePanel">
          <app-alert-case [alert]="fullAlert" [context]="alertCaseContext" [preload$]="alertCase$" [embedded]="true"></app-alert-case>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<mat-dialog-actions class="adlg-footer">
  <span class="adlg-kbd"><ng-container *ngIf="showStepper"><kbd>←</kbd><kbd>→</kbd> {{ '@siblings' | translate }} &nbsp; </ng-container><kbd>Esc</kbd> {{ '@close' | translate }}</span>
  <span class="adlg-spacer"></span>
  <button mat-stroked-button class="adlg-vehicle-btn" [disabled]="!vin" (click)="viewVehicle()">
    <mat-icon class="adlg-btn-icon">local_shipping</mat-icon>
    {{ '@vehicleDetails' | translate }}
  </button>
  <button mat-stroked-button class="adlg-copy-btn" (click)="copyLink()">
    <mat-icon class="adlg-btn-icon">{{ linkCopied ? 'check' : 'link' }}</mat-icon>
    {{ (linkCopied ? '@linkCopied' : '@copyLink') | translate }}
  </button>
</mat-dialog-actions>

<ng-template #faultRow let-fault>
  <span class="adlg-fr-name" [matTooltip]="fault.failureCodeDisplay || fault.description">
    <span class="adlg-fr-base">{{ fault.description || fault.faultCodeDisplay }}</span>
  </span>
  <span class="adlg-fr-code">{{ codeLabel(fault) }}</span>
  <span><ng-container *ngTemplateOutlet="faultNow; context: { $implicit: fault }"></ng-container></span>
  <span class="adlg-fr-count">{{ fault.faultCount }}</span>
  <span class="adlg-fr-when" [matTooltip]="fault.faultDateUtc | date:'medium'">{{ fault.faultDateUtc | date:'MMM d, h:mm a' }}</span>
</ng-template>

<ng-template #faultNow let-fault>
  <span class="adlg-fchip" *ngIf="fault.now" [class.on]="fault.now === 'active'">{{ (fault.now === 'active' ? '@issueFaultActive' : '@issueFaultInactive') | translate }}</span>
</ng-template>

<ng-template #lampMark let-count>
  <span class="adlg-seg-mark" *ngIf="count" data-e2e="adlg-lamp-change-mark" role="img"
        [matTooltip]="'@lampsChangedSinceAlert' | translate: { count: count }"
        [attr.aria-label]="'@lampsChangedSinceAlert' | translate: { count: count }">{{ count }}</span>
</ng-template>

<ng-template #miniLamps let-lamps>
  <span class="adlg-lamps-mini" *ngIf="lamps">
    <img class="adlg-lamp-mini" *ngFor="let lamp of lamps" [class.on]="lamp.on" alt=""
         [src]="lampSrc(lamp)" [matTooltip]="(lamp.on ? lamp.onKey : lamp.offKey) | translate">
  </span>
</ng-template>
